module.exports = __webpack_public_path__ + "img/hand-holding-usd.29f8f112.svg";